import { API_REQUEST, GET_ALL_PROFILES_BY_ROLL, SEARCH_PROFILE_BY_ROLL } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const searchProfileByRoll = (roll: string, wac: string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/profile/roll-search/${roll}/${wac}`,
    next: SEARCH_PROFILE_BY_ROLL,
    method: 'GET',
    authorization: true
  }
});

export const getAllProfilesByRoll = (roll: string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/profiles/${roll}`,
    next: GET_ALL_PROFILES_BY_ROLL,
    method: 'GET',
    authorization: true
  }
})